import Swiper, { Grid, Navigation, Pagination, Lazy } from "swiper";

export const initClients = () => {
  new Swiper(".clients__slider", {
    modules: [Grid, Navigation, Pagination, Lazy],
    speed: 500,
    slidesPerView: 6,
    grid: {
      fill: "row",
      rows: 1,
    },
    spaceBetween: 30,
    navigation: {
      nextEl: ".clients .slider-button_next",
      prevEl: ".clients .slider-button_prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.45,
        spaceBetween: 10,
      },
      430: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
      1150: {
        slidesPerView: 6,
        spaceBetween: 32,
      },
    },
  });
};
